import { withTranslation } from "next-i18next";
import { Button } from "@components/core";
import ProductRecentCommentCard from "./ProductRecentCommentCard";

function ProductRecentComments({ product, openCompleteReviews, t }) {
  if (!product.recent_comments.length) return null;

  return (
    <section className="container py-4 my-2">
      <div className="row">
        <div className="pb-4 mb-2">
          <h3 className="text-center mb-0">
            {t("product:reviews_title")}
          </h3>

          <p className="text-gray text-center">
            {t("product:ratings_count", { count: product.ratings_count })}
          </p>
        </div>

        <div className="product-recent-comment-cards-container">
          {product.recent_comments.map((review) => (
            <ProductRecentCommentCard
              key={review.id}
              review={review}
            />
          ))}
        </div>

        <div className="w-100 d-flex justify-content-center">
          <Button
            variant="outline-primary"
            onClick={openCompleteReviews}
            hugContent
          >
            {t("product:reviews_see_all")}
          </Button>
        </div>
      </div>
    </section>
  );
}

export default withTranslation("product")(ProductRecentComments);
